import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  Chip,
  Checkbox,
  Radio,
  Box,
} from '@mui/material'
import { styles } from './styles'
import { useContext, useEffect, useState, type FC } from 'react'
import { CompanyStatus } from '../CompanyStatus'
import { useNavigate } from 'react-router-dom'
import type { CompanyParams } from '@/api/models/company'
import { OrganizationListContext } from '../../OrganizationList'
import { useModal } from '@/hooks'
import { ModalType } from '@/store/app'
import type { Item } from '@/components'
import { useCompany } from '@/hooks/useCompany'
import { TableHeadCell } from '@/modules/MedComplexList/components/MedComplexTable/components'

// const headCells: string[] = ['Действующая', 'Название организации', 'Статус']

export const OrganizationTable = () => {
  const { companies, cards } = useContext(OrganizationListContext)
  const navigate = useNavigate()
  // const { showModal, hideModal } = useModal()

  // const [getUser] = useLazyGetCurrentUserQuery()
  // const [getEmployee] = useLazyGetEmployeeByIdQuery()
  // const [updateEmployee] = useUpdateEmployeeMutation()

  // // eslint-disable-next-line @typescript-eslint/no-explicit-any
  // const [currentEmployee, setCurrentEmployee] = useState<any>()
  // const [currentCompany, setCurrentCompany] = useState<number>()

  // useEffect(() => {
  //   // eslint-disable-next-line @typescript-eslint/no-explicit-any
  //   getUser().then((response: any) => {
  //     getEmployee({ companyId: 1, employeeId: response.data.id }).then(
  //       // eslint-disable-next-line @typescript-eslint/no-explicit-any
  //       (response: any) => {
  //         setCurrentEmployee(response.data)
  //         setCurrentCompany(response.data.roles[0].product.id)
  //       }
  //     )
  //   })
  // }, [])

  // const [updateCompany] = useUpdateCompanyMutation()

  // const onChangeMain = (company: CompanyParams) => {
  //   if (currentEmployee) {
  //     updateEmployee({
  //       companyId: 1,
  //       employeeId: currentEmployee?.id ?? 7,
  //       payload: {
  //         ...currentEmployee,
  //         roles: [
  //           {
  //             ...currentEmployee.roles[0],
  //             product: {
  //               ...currentEmployee.roles[0].product,
  //               id: company.id,
  //             },
  //           },
  //         ],
  //       },
  //     }).then(() => {
  //       //refetchCompanies()
  //       setCurrentCompany(company.id)
  //     })
  //     showModal(ModalType.ORGANIZATION_CHANGE)
  //     setTimeout(() => {
  //       hideModal()
  //     }, 2100)
  //   }
  // }

  const { activeCompany, changeCompany } = useCompany()

  return (
    <Box sx={styles.scrollBar}>
      <TableContainer sx={styles.tableContainer}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {/* {headCells.map((cell, index) => (
              <TableCell sx={styles.headCell} key={index.toString()}>
                <>{cell}</>
              </TableCell>
            ))} */}
              <TableCell sx={{ backgroundColor: '#FAFAFA' }}>
                Действующая
              </TableCell>
              {cards?.map((card: Item) =>
                card?.visible || !!card?.alwaysVisible ? (
                  // <TableCell sx={styles.headTableCell} key={card.id}>
                  //   {card.text}
                  // </TableCell>
                  <TableHeadCell item={card} key={card?.id} />
                ) : null
              )}
              <TableCell
                sx={{ backgroundColor: '#FAFAFA', width: '100%' }}
              ></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {companies?.data?.map((item: CompanyParams) =>
              item?.status === 'DELETED' ? null : (
                <TableRow
                  key={item.id}
                  sx={styles.tableRow}
                  onClick={() => navigate(`/organization/${item.id}/general`)}
                >
                  <TableCell
                    sx={{
                      backgroundColor: '#FAFAFA',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                    onClick={(e) => {
                      e.stopPropagation()
                      changeCompany(item?.id)
                    }}
                  >
                    <Radio
                      disableRipple
                      checked={activeCompany?.id === item?.id}
                      onClick={(e) => e.stopPropagation()}
                      onChange={() => changeCompany(item?.id)}
                    />
                  </TableCell>
                  {cards?.map((card: Item) =>
                    card.visible || !!card?.alwaysVisible ? (
                      <TableCell key={card.id}>{card.data(item)}</TableCell>
                    ) : null
                  )}
                  <TableCell></TableCell>
                  {/* <TableCell>
                <Radio
                  disableRipple
                  checked={currentCompany === item.id}
                  onClick={(e) => e.stopPropagation()}
                  onChange={(e) => onChangeMain(item)}
                  value="true"
                  name="radio-buttons"
                />
              </TableCell>
              <TableCell>{item.short_title}</TableCell>
              <TableCell>
                <CompanyStatus status={item.status} />
              </TableCell> */}
                </TableRow>
              )
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}
